import type { QueryClient } from '@tanstack/react-query';

/**
 * 일정 목록이 캐시되는 쿼리 키 전부.
 *
 * SchedulePage 가 뷰 모드(일간·주간·스마트·목록)마다 다른 키를 쓴다.
 * 하나라도 빠뜨리면 그 뷰에서만 옛 데이터가 남는다.
 *  - getDailyScheduleAPI       SchedulePage.tsx:373  (달력 · 일간)
 *  - getWeeklyScheduleAPI      SchedulePage.tsx:704  (달력 · 주간)
 *  - getListRangeSchedulesAPI  SchedulePage.tsx:560  (목록)
 *  - getSmartRangeSchedulesAPI SchedulePage.tsx:1080 (스마트)
 *
 * `ScheduleManage` 의 일간·주간 화면도 `getDailyScheduleAPI` 접두 키를 그대로 쓴다
 * (DailySchedulePage.tsx:124 · WeeklySchedulePage.tsx:49). 접두 무효화라 함께 걸린다.
 *
 * 일정 쓰기(등록·수정·삭제)와 회원 이름 수정이 **같은 목록을 무효화해야** 하는데,
 * 목록이 두 벌로 갈리면 뷰를 하나 추가했을 때 한쪽만 갱신되는 사고가 난다.
 * 그래서 정의는 여기 한 곳에만 둔다.
 */
export const SCHEDULE_LIST_QUERY_KEYS = [
    ['getDailyScheduleAPI'],
    ['getWeeklyScheduleAPI'],
    ['getListRangeSchedulesAPI'],
    ['getSmartRangeSchedulesAPI'],
];

/**
 * 일정 목록 캐시를 stale 로 표시한다(기본 `invalidateQueries`).
 *
 * 관찰자가 붙어 있지 않은 화면에서 부르면 요청이 즉시 나가지 않고 **다음에 열 때**
 * 갱신된다. 일정 화면과 다른 라우트에서 일어나는 변경(회원 이름 수정 등)을 반영하는
 * 용도라 이걸로 충분하다. 지금 열려 있는 목록까지 강제로 다시 받아야 하는 경로는
 * `refreshScheduleWriteQueries` 처럼 별도의 조회를 덧붙여 쓴다.
 */
export const invalidateScheduleListQueries = (queryClient: QueryClient) => {
    SCHEDULE_LIST_QUERY_KEYS.forEach((queryKey) => {
        queryClient.invalidateQueries({ queryKey });
    });
};
